module.exports = __webpack_public_path__ + "assets/img/ktz_img31.6538e0cd.png";